import { uiConfig } from '../app-ui-config';

const SUPPORT_EMAIL = uiConfig.supportEmail;
const SUPPORT_PHONE = '+14247990744';
const SUPPORT_PHONE_DISPLAY = '+1 (424) 799-0744';

export {
    SUPPORT_EMAIL,
    SUPPORT_PHONE,
    SUPPORT_PHONE_DISPLAY
};
